import { timelineGroups } from "@/mocks/eventArchive";

const stateStyle: Record<string, string> = {
  "热度顶点": "bg-primary-100 text-primary-800 border-primary-200",
  "各说各话": "bg-secondary-100 text-secondary-900 border-secondary-200",
  "反复横跳": "bg-accent-100 text-accent-900 border-accent-200",
  "等待定论": "bg-background-200 text-foreground-700 border-background-300",
};

export default function TimelineSection() {
  return (
    <section id="shijianxian" className="border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl px-4 py-16 md:px-6 md:py-24">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="sec-kicker inline-flex items-center gap-2 text-xs font-semibold text-primary-600">
              <span className="h-px w-8 bg-primary-400"></span>全记录时间线
            </span>
            <h2 className="font-head-cn mt-3 text-2xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              完整始末，按时间对应关系叠好
            </h2>
          </div>
          <div className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-4 py-2 text-sm font-medium text-accent-900">
            <i className="ri-alarm-warning-line"></i>关键时间节点已加粗标注，事实以官方与当事人说明为准
          </div>
        </div>

        <div className="mt-10 space-y-14 md:mt-14 md:space-y-20">
          {timelineGroups.map((group) => (
            <div key={group.phaseId} className="relative">
              {/* 阶段头 */}
              <div className="mb-8 flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-5 md:flex-row md:items-center md:justify-between">
                <div className="flex items-center gap-4">
                  <span className="font-num text-4xl text-primary-500">
                    {String(timelineGroups.indexOf(group) + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3 className="font-head-cn text-lg font-bold text-foreground-950 md:text-xl">
                      {group.phase}
                    </h3>
                    <p className="text-sm text-foreground-600">{group.date}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <span
                    className={`inline-flex items-center rounded-full border px-3 py-1 text-xs font-semibold whitespace-nowrap ${
                      stateStyle[group.state] || stateStyle["等待定论"]
                    }`}
                  >
                    <i className="ri-radar-line mr-1"></i>{group.state}
                  </span>
                  <span className="hidden text-sm text-foreground-500 sm:inline">{group.items.length} 个节点</span>
                </div>
              </div>

              <p className="mb-6 max-w-3xl text-sm leading-7 text-foreground-700 md:pl-0">{group.intro}</p>

              {/* 节点列表 */}
              <ol className="relative ml-3 border-l border-background-300 pl-6 md:ml-4 md:pl-10">
                {group.items.map((item, idx) => (
                  <li key={idx} className="relative mb-8 last:mb-0">
                    <span
                      className={`absolute -left-[31px] top-1 flex h-3 w-3 items-center justify-center rounded-full ring-4 ring-background-100 md:-left-[45px] ${
                        idx === 0 || idx === group.items.length - 1 ? "bg-primary-500" : "bg-background-300"
                      }`}
                    ></span>
                    <div className="flex flex-col gap-1.5 md:flex-row md:items-baseline md:gap-5">
                      <span className="font-num whitespace-nowrap text-base tracking-wide text-foreground-500 md:w-32 md:text-lg">
                        {item.time}
                      </span>
                      <div>
                        <span className="mr-3 inline-flex items-center rounded-sm bg-secondary-100 px-2 py-0.5 text-xs font-semibold text-secondary-900">
                          {item.tag}
                        </span>
                        <p className="inline text-sm leading-7 text-foreground-800 md:text-[15px]">{item.text}</p>
                      </div>
                    </div>
                  </li>
                ))}
              </ol>
            </div>
          ))}
        </div>

        <div className="mt-12 flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
          <i className="ri-information-line text-lg text-accent-700"></i>
          <p className="text-sm leading-6 text-foreground-700">
            读图顺序建议：先看每个阶段的<b className="text-foreground-950">日期跨度</b>，再回到节点逐条对照——多数「反转」实际来自时间对应关系的先后颠倒。
          </p>
        </div>
      </div>
    </section>
  );
}